import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { ISelectProposalHook } from '../../modal-select-proposal.types'
import { PriceObjectOutputDto } from '../../../../../lib/graphql'
import { getPriceFromToggleStatus, roundedPrice } from '../../../../../utils'
import { VatLabel } from '../../../../atoms'
import { useCurrencyAreaContext, usePriceContext } from '../../../../contexts'

export const ModalSelectProposalFooterPrice = ({
  total,
  adults,
  isByPerson,
  isAuthenticated,
}: {
  total: Pick<PriceObjectOutputDto, 'priceWithDiscountAndFees'> | undefined
  adults?: number
  isByPerson?: boolean
  isAuthenticated: ISelectProposalHook['isAuthenticated']
  backoffice?: boolean
}) => {
  const toggleStatus = usePriceContext()
  const { currency } = useCurrencyAreaContext()

  const getValue = () => {
    if (!isAuthenticated) {
      return '100'
    }
    if (!total || (isByPerson && !adults)) {
      return '-'
    }

    let priceToDisplay = getPriceFromToggleStatus({
      priceOption: total,
      toggleStatus,
      total: true,
    })

    if (isByPerson && adults) {
      priceToDisplay = priceToDisplay / adults
    }

    return `${roundedPrice(priceToDisplay, { currency })}`
  }

  return (
    <p className={clsx({ [s.blur]: !isAuthenticated })}>
      {getValue()} <VatLabel />
      {isByPerson && ' / pers.'}
    </p>
  )
}
